<template>
  <div class="personal-list">
    <vuedraggable element="div" v-bind="dragOptions()" filter=".forbid" :list="dataset" @update="end" @add="end" :disabled="!itemMove">
      <div class="list-task-item" :class="{'task-complete':isCompete(item.status),'forbid':!item.move_permission,'isOnlyReal':onlyReal,'check-active':check == item.id}" v-for="(item,index) in dataset" :key="item.id" @click="openDetail(index)">
        <div class="dot" v-if="item.todo_mobile_history && item.todo_mobile_history.length > 0 && item.todo_mobile_history[0].is_read === 0 ">
          <toolTip :show="true" :title="item.todo_mobile_history[0].move_todo_user.realname + '调整了排序'">
            <div style="width:6px;height:6px;"></div>
          </toolTip>
        </div>
        <div class="left">
          <div @click.stop v-if="!onlyReal">
            <el-checkbox class="list-checkbox" @change="taskStatusChange(item.id,index,isCompete(item.status))" :value="isCompete(item.status)"></el-checkbox>
          </div>
          <toolTip style="width:100%" :title="item.title">
            <span>{{item.title}}</span>
          </toolTip>
        </div>
        <div class="right" @click.stop :class="{'disabled-round':isCompete(item.status) || onlyReal}">
          <SelectTime v-model="item.due_date" @change="timeChange(item,index)" :disabled="isCompete(item.status) || onlyReal">
            <span v-if="item.due_date">{{item.due_date ? item.due_date.replace(/-/g,'/') : ''}}</span>
            <div class="tip-btn" v-else>
              <i class="icon iconfont iconicon_time1"></i>
            </div>
          </SelectTime>
          <SelectColor v-model="item.colorMark" @change="colorChange(item,index)" :disabled="isCompete(item.status) || onlyReal">
            <a class="round-box" v-if="item.color_mark" :style="{'background':item.color_mark ? item.color_mark.color_number : ''}"></a>
            <div class="tip-btn" v-else>
              <i class="icon iconfont iconicon_sign"></i>
            </div>
          </SelectColor>
        </div>
      </div>
    </vuedraggable>
    <div v-if="!finish" class="loading-box" @click="loadMore">
      <i v-if="loading" class="el-icon-loading"></i>
      <div v-else>
        <span>查看更多</span>
        <i class="icon iconfont iconicon_arrow_task"></i>
      </div>
    </div>
  </div>
</template>
<script>
import SelectColor from './selectColor'
import SelectTime from './selectTime'
import vuedraggable from "vuedraggable";
import api from '@/services/api/mine/mine'
export default {
  props: ['dataset', 'finish', 'load', 'onlyReal', 'itemMove', 'check'],
  components: {
    SelectColor,
    SelectTime,
    vuedraggable
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    isCompete() {
      return status => {
        return status === 1 ? false : true
      }
    }
  },
  methods: {
    taskStatusChange(id, index, isCompete) {
      this.$emit('taskStatusChange', { id, index, isCompete: !isCompete })
    },
    colorChange(item, index) {
      this.$emit('colorChange', { item, index })
    },
    timeChange(item, index) {
      this.$emit('timeChange', { item, index })
    },
    end(e) {
      let newIndex = e.newIndex
      let id = this.dataset[newIndex].id // 当前id
      let previous_id = newIndex > 0 ? this.dataset[newIndex - 1].id : 0 // 上一个id
      let next_id = newIndex == (this.dataset.length - 1) ? 0 : this.dataset[newIndex + 1].id // 下一个id
      api.updateTodoSort({ id, previous_id, next_id })
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'task',
        disabled: false
      }
    },
    openDetail(index) {
      this.dataset[index].todo_mobile_history = []
      this.$emit('openDetail', this.dataset[index].id)
    },
    loadMore() {
      this.loading = true
      this.load(res => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss">
.personal-list {
  // padding-bottom: 11px;
  .loading-box {
    padding-left: 52px;
    font-size: 14px;
    color: rgba(32, 32, 32, 0.6);
    padding-top: 24px;
    padding-bottom: 29px;
    cursor: pointer;
    i {
      font-size: 14px;
      margin-left: 4px;
    }
    > div {
      cursor: pointer;
      display: inline-block;
      &:hover {
        color: #2682ff;
      }
      &:active {
        color: #0463d6;
      }
    }
  }
  .check-active {
    background-color: #eaebec !important;
  }
  .list-task-item {
    height: 48px;
    line-height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 53px;
    position: relative;
    cursor: pointer;
    border-bottom: 1px solid rgba(32, 32, 32, 0.08);
    &:hover {
      background-color: #f7f8f9;
      .right .tip-btn {
        visibility: visible;
      }
    }
    &:active {
      background-color: #eaebec;
    }
    .left {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: initial;
      width: 60%;
      > span {
        margin-left: 8px;
      }
      .list-checkbox {
        margin-right: 8px;
      }
    }
    .right {
      display: flex;
      align-items: center;
      .round-box {
        &:hover {
          width: 18px;
          height: 18px;
          line-height: 18px;
          text-align: center;
          opacity: 0.8;
          transform: translate(3px, 0);
          // &::after {
          //   content: "\e7c0";
          //   font-family: "iconfont";
          //   color: #fff;
          // }
        }
        &:active {
          opacity: 0.6;
        }
      }
      .tip-btn {
        color: rgba(32, 32, 32, 0.6);
        font-size: 14px;
        visibility: hidden;
        z-index: 99;
        text-align: right;
        .icon {
          margin: 0;
        }
        span {
          margin-left: 2px;
        }
        i {
          font-size: 14px;
        }
        &:hover {
          // background-color: #f7f8f9;
          color: $color-active !important;
        }
        &:active {
          // background-color: #eaebec;
          color: #0463d6 !important;
        }
      }
      a {
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        flex-shrink: 0;
      }
      .btn-box {
        border: 0 none;
        // width: 110px;
        width: 12px;
        text-align: right;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0;
        margin-right: 24px;
        &:hover {
          // background-color: #f7f8f9;
          color: $color-active !important;
        }
        &:active {
          background-color: #eaebec;
          // color: #0463d6 !important;
        }
      }
    }
    .dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: linear-gradient(225deg, #6b97cf 0%, #456fb3 100%);
      flex-shrink: 0;
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      left: 28px;
      z-index: 1;
    }
  }
  .task-complete {
    > *:not(.left) {
      opacity: 0.4;
    }
    .left {
      .tool-tip {
        opacity: 0.4;
      }
    }
    &:hover {
      .right .tip-btn {
        visibility: hidden;
      }
    }
  }
  .isOnlyReal {
    &:hover {
      .right .tip-btn {
        visibility: hidden;
      }
    }
  }
  .disabled-round {
    pointer-events: none;
  }
}
</style>
